import { AUDIO_GRAPHS } from '../globals';
import { getValueForKey } from './get-value-for-key';
export function getAudioGraph(context) {
  return getValueForKey(AUDIO_GRAPHS, context);
}